import { createFileRoute, Outlet } from '@tanstack/react-router';

import { useWorkspace } from '@/app/context';
import { filterNav, ORG_NAV } from '@/app/navigation';
import { orgNavFor } from '@/app/person-nav';
import { PageHeader } from '@/components/common/page-header';
import { EmptyState } from '@/components/common/states';
import { useActiveNavItem } from '@/components/shell/use-active-nav';
import { useT } from '@/i18n/react';

export const Route = createFileRoute('/_app/org/$orgId')({ component: OrgLayout });

function OrgLayout() {
  const t = useT();
  const { orgId } = Route.useParams();
  const { org, nav } = useWorkspace();
  // The company's sections are in the sidebar (the "More" drawer on a phone).
  const active = useActiveNavItem(filterNav(org ? orgNavFor(org) : ORG_NAV, nav), { orgId });
  if (!org) {
    return (
      <EmptyState
        title={t('Company not available')}
        description={t('You are not a member of this company.')}
      />
    );
  }
  return (
    <>
      <PageHeader
        eyebrow={[t('Company'), active && t(active.label)].filter(Boolean).join(' / ')}
        title={org.name}
      />
      <Outlet />
    </>
  );
}
